
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 7h14c4.959 0 9 4.041 9 9s-4.041 9-9 9H9c-.94 0-1.835-.137-2.688-.406a8.579 8.579 0 01-.813-.313 9.067 9.067 0 01-5.094-5.594c-.003-.009.003-.022 0-.031A8.843 8.843 0 01-.001 16c0-.94.137-1.835.406-2.688.088-.282.198-.543.313-.813a9.067 9.067 0 015.594-5.094c.282-.088.582-.159.875-.219A9.028 9.028 0 019 6.998zm0 2a6.988 6.988 0 00-6.969 6.281A7.115 7.115 0 002 16c0 3.878 3.123 7 7 7s7-3.122 7-7-3.122-7-7-7zm5.625 0C16.676 10.652 18 13.171 18 16s-1.324 5.348-3.375 7H23c3.878 0 7-3.122 7-7s-3.122-7-7-7h-8.375z"}})])
          )
        }
      }
    